import { FULL_DATE } from '@/constants/dateFormat';
import dayjs from 'dayjs';
import * as Yup from 'yup';

/**
 * 投诉分类(多选)
 */
export interface CasesCategory {
  /**
   * 投诉分类id
   */
  cases_category_id: number;
}

/**
 * 投诉处理赔偿(多选)
 */
export interface CasesDispose {
  /**
   * 投诉处理赔偿id
   */
  cases_dispose_id: number;
}

/**
 * 投诉建议
 */
export interface SuggestInfo {
  /**
   * 服务id(编辑的时候传)
   */
  id?: string;
  /**
   * 会员id
   */
  member_id?: string;
  /**
   * 非会员id
   */
  not_member_id?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 投诉发生日期
   */
  cases_day: string;
  /**
   * 接受投诉日期
   */
  cases_receive_day: string;
  /**
   * 投诉来源
   */
  cases_source: string;
  /**
   * 投诉具体描述
   */
  cases_remark: string;
  /**
   * 被投诉对象
   */
  cases_brand: string;
  /**
   * 投诉分类
   * - 提交时转json字符串 里面包含以下数据,如果是修改里面要加id字段,如果删除的数据不要传给后台
   */
  cases_category: CasesCategory[];
  /**
   * 投诉处理状态
   */
  cases_status: number;
  /**
   * 处理大使id
   */
  dispose_ge_id: number;
  /**
   * 零售经理id
   */
  dispose_retail_id: number;
  /**
   * 处理详情
   */
  dispose_remark: string;
  /**
   * 处理结果(编辑时才有)
   */
  dispose_result?: string;
  /**
   * 投诉处理赔偿
   * - 提交时转json字符串 里面包含以下数据,如果是修改里面要加id字段,如果删除的数据不要传给后台
   */
  cases_dispose: CasesDispose[];
}

/**
 * 投诉建议创建表单默认值
 */
export const defaultSuggestInfo: SuggestInfo = {
  cases_day: dayjs(new Date()).format(FULL_DATE),
  cases_receive_day: dayjs(new Date()).format(FULL_DATE),
  cases_source: '',
  cases_remark: '',
  cases_brand: '',
  cases_category: [],
  cases_status: 1, // 默认待处理状态
  dispose_ge_id: null,
  dispose_retail_id: null,
  dispose_remark: '',
  cases_dispose: [],
};

/**
 * 投诉建议详情表单默认值
 */
export const defaultSuggestEditInfo: SuggestInfo = {
  cases_day: '',
  cases_receive_day: '',
  cases_source: '',
  cases_remark: '',
  cases_brand: '',
  cases_category: [],
  cases_status: null,
  dispose_ge_id: null,
  dispose_retail_id: null,
  dispose_remark: '',
  dispose_result: '',
  cases_dispose: [],
};

/**
 * 投诉建议表单校验
 */
export const suggestSchema = Yup.object({
  cases_day: Yup.string().ensure().required('请选择投诉发生日期'),
  cases_receive_day: Yup.string().ensure().required('请选择投诉接收日期'),
  cases_source: Yup.string().ensure().required('请选择投诉来源'),
  cases_status: Yup.number().typeError('请选择投诉处理状态').required('请选择投诉处理状态'),
});